export default __webpack_public_path__ + "static/media/logo01.b3edf4b9.svg";